var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcFileLogArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3496 19.5H18.4785L16.539 21.4394L17.5996 22.5L21.3496 18.75L17.5996 15L16.539 16.0606L18.4785 18H12.3496V19.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0996 15.75H6.34961V17.25H10.0996V15.75Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8496 12H6.34961V13.5H13.8496V12Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3746 6.975L12.1246 1.725C11.9746 1.575 11.8246 1.5 11.5996 1.5H4.09961C3.27461 1.5 2.59961 2.17492 2.59961 3V21C2.59961 21.8272 3.27273 22.5 4.09961 22.5H10.0996V21H4.09961V3H10.0996V7.5C10.0996 8.32508 10.7746 9 11.5996 9H16.0996V13.5H17.5996V7.5C17.5996 7.275 17.5246 7.125 17.3746 6.975ZM11.5996 7.5V3.29992L15.7996 7.5H11.5996Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFileLogArrow);
export default __webpack_public_path__ + "static/media/ic-file-log-arrow.8f45fea9bc6916f7a311aa1e8b63a706.svg";
export { ForwardRef as ReactComponent };